import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import * as R from "ramda"
import GatewayComponent from '../components/gateway/gateway.component';
import { useAppDispatch } from '../../../../hooks/hooks';
import { selectGatewaysQueryItems } from '../../../../redux/gateways/selector';
import { selectTenantOpennetworkDomainsListItems } from '../../../../redux/dbn-cloud/tenant-open-network-domains/selector';
import { selectNetworksListItems } from '../../../../redux/dbaas/networks/selector';
import { selectDbasListItems } from '../../../../redux/dbn-cloud/dbas/selector';
import { gateways } from '../../../../redux/gateways/action';
import { dbas } from '../../../../redux/dbn-cloud/dbas/action';
import { networks } from '../../../../redux/dbaas/networks/action';
import { tenantOpenNetworkDomains } from '../../../../redux/dbn-cloud/tenant-open-network-domains/action';
import PageLoader from '../../../../components/PageLoader';

const Gateway = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const queryItems = useSelector(selectGatewaysQueryItems)
  const domainItems = useSelector(selectTenantOpennetworkDomainsListItems)
  const NetworkItems = useSelector(selectNetworksListItems)
  const dbasItems = useSelector(selectDbasListItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [
    selectedGateway,
    setSelectedGateway
  ] = useState<any>([])

  const fetchGatewayById = () => {
    dispatch(gateways.query({
      url: `https://edgegateway.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dbn-cloud/gateways/query`, entity: 'gateways', jsonData: {
        Context: {},
        Records: [
          {
            "Id": parmas?.id
          }
        ]
      }
    })).then(() => {
      setIsQuery(true)
    })
  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedGateway({ ...selectedGateway, [field]: event });
  }

  const handleFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setSelectedGateway({ ...selectedGateway, [fields[0]]: value });
  }

  useEffect(
    () => {
      dispatch(networks.list({
        url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/networks/list`,
        entity: 'networks',
        jsonData: {}
      })).then(() => {
        dispatch(tenantOpenNetworkDomains.list({
          url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/domains/list`,
          entity: 'tenantOpenNetworkDomains',
          jsonData: {}
        })).then(() => {
          dispatch(dbas.list({
            url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbn-cloud/dbas/list`,
            entity: 'dbas',
            jsonData: {
            }
          }))
        })
        if (parmas?.id > 0) {
          fetchGatewayById()
        }
      })
    },
    []
  )
  useEffect(
    () => {
      if (isQuery) {
        setSelectedGateway(queryItems?.result?.items)
      }
    },
    [isQuery]
  )

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    if (parmas?.id > 0) {
      await dispatch(gateways.resetAction({ actionType: 'update' }))
      await dispatch(gateways.update({
        url: `https://edgegateway.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dbn-cloud/gateways`, entity: 'dbass', jsonData: {
          Context: {},
          Records: [
            {
              ...selectedGateway,
              Cities: selectedGateway?.IsLimitedToCities ? selectedGateway?.Cities : ['*']
            }
          ]
        }
      })).then(() => {
        back()
      })
    } else {
      await dispatch(gateways.resetAction({ actionType: 'create' }))
      await dispatch(gateways.create({
        url: `https://edgegateway.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dbn-cloud/gateways`, entity: 'dbass', jsonData: {
          Context: {},
          Records: [
            {
              ...selectedGateway,
              Cities: selectedGateway?.IsLimitedToCities ? selectedGateway?.Cities : ['*']
            }          ]
        }
      })).then(() => {
        back()
      })
    }
  }

  const back = () => {
    navigate('/management/dbn-cloud/gateways')
  }


  return (
    <>
      {domainItems?.isLoading || NetworkItems?.isLoading || dbasItems?.isLoading ? <PageLoader /> :
        <GatewayComponent
          handleInnerFormChange={handleInnerFormChange}
          selectedGateway={selectedGateway}
          domainDetails={domainItems?.result?.items}
          networks={NetworkItems?.result?.items}
          back={back}
          handleFormSubmit={handleFormSubmit}
          handleFormChange={handleFormChange}
          dbas={dbasItems?.result?.items}
        />
      }
    </>
  )

}

export default Gateway;
